import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { X } from "lucide-react";

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get("/portfolio").then((r) => setItems(r.data));
  }, []);

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-24 lg:py-32 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="mb-10">
            <p className="font-mono-label text-[11px] text-neutral-500 mb-4">
              01 · Gallery
            </p>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            Gallery.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {items.map((i, idx) => (
            <button
              key={i.id}
              data-testid={`portfolio-item-${i.id}`}
              onClick={() => setLightbox(i)}
              className={`group relative overflow-hidden border border-neutral-900 aspect-[4/5] ${
                idx % 5 === 0 ? "md:col-span-2 md:row-span-1 md:aspect-[16/10]" : ""
              }`}
            >
              <img
                src={i.image_url}
                alt={i.title}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
              />
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          data-testid="portfolio-lightbox"
          className="fixed inset-0 z-[80] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 md:p-8"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 text-[#F5F5F0] z-10"
            data-testid="lightbox-close"
            onClick={() => setLightbox(null)}
          >
            <X size={28} />
          </button>
          <img
            src={lightbox.image_url}
            alt=""
            className="max-w-[95vw] max-h-[95vh] w-auto h-auto object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
